
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";

@Component({
  components: {},
  filters,
})
export default class NewsFromAdmin extends Vue {
  @Action("actionGetNewsFromAdmin", { namespace: "information" })
  private actionGetNewsFromAdmin: any;

  private created() {
    this.actionGetNewsFromAdmin();
  }

  private onMoreNews() {
    this.$router.push({
      name: "newsFromAdmin",
    });
  }
}
